import { render, staticRenderFns } from "./DutyTypeEditor.vue?vue&type=template&id=47956c94"
import script from "./DutyTypeEditor.vue?vue&type=script&lang=js"
export * from "./DutyTypeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports